module.exports = __webpack_public_path__ + "img/slika64.a3d09f00.jpg";